import { ActionSideEffect, ActionSideEffectTypesEnum } from '@spazious/dollhouse-commander';
import { findStackableNode, FSetupGraph } from '@spazious/dollhouse-fsetup';
import {
  FShallowGraph,
  FShallowNodeTypesEnum,
  isFArrangementShallowNode,
} from '@spazious/dollhouse-shallow-graph';

export const updateNodesStacking = (
  shallowGraph: FShallowGraph,
  graph: FSetupGraph
): ActionSideEffect[] => {
  if (!graph) {
    return [];
  }
  const effects: ActionSideEffect[] = [];
  const { nodes } = shallowGraph;
  const stackedNodes = new Set<string>();
  Object.entries(nodes)
    .reverse()
    .forEach(([selector, node]) => {
      if (
        node.type === FShallowNodeTypesEnum.FGroup ||
        !node.position ||
        isFArrangementShallowNode(node)
      ) {
        return;
      }
      const parent = findStackableNode(
        graph as any,
        shallowGraph,
        node.position,
        selector,
        node.type
      );
      let newParentSelector = parent?.node.selector;
      if (newParentSelector && !nodes[newParentSelector]) {
        // node is deleted in shallow graph
        newParentSelector = undefined;
      } else if (newParentSelector && stackedNodes.has(newParentSelector)) {
        // parent is already stacked
        newParentSelector = undefined;
      }

      if (node.parent !== newParentSelector) {
        stackedNodes.add(selector);
        effects.push({
          type: ActionSideEffectTypesEnum.Stacking,
          selector: selector,
          parent: newParentSelector,
          positionY: newParentSelector ? parent?.positionY ?? 0 : 0,
        });
      }
    });

  return effects;
};
